<template>
    <g>
        <rect y="0.5" width="16" height="16" rx="3" fill="#206CFF" />
        <path
            d="M6.46154 11.5686L5.90475 12.0711L6.46154 12.6881L7.01832 12.0711L6.46154 11.5686ZM3.44321 9.34356L5.90475 12.0711L7.01832 11.0661L4.55679 8.33859L3.44321 9.34356ZM7.01832 12.0711L12.5568 5.93412L11.4432 4.92916L5.90475 11.0661L7.01832 12.0711Z"
            fill="white"
        />
    </g>
</template>
<script>
export default {
    name: "CheckedBlue",
};
</script>
